import { createClient } from '@supabase/supabase-js';
import { reportSafeDiagnostic } from './safeDiagnostics.js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON) {
  reportSafeDiagnostic('error', 'supabase_browser_configuration_missing', { stage:'initialize_supabase_client' });
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth:{
    // Recovery/invitation callbacks are exchanged exactly once by
    // recoverPasswordSetupSession. Session persistence, refresh, and storage
    // remain at the Supabase browser defaults for ordinary signed-in sessions.
    detectSessionInUrl:false,
  },
});
